/*
 * DattriuSteer · Mejoras de la tienda
 * Capa ligera que se carga después de script.js:
 *  - Traduce al español los textos que aún estaban en inglés (ficha de producto,
 *    carrito y ventana de descuento), también cuando script.js los cambia.
 *  - Corrige el enlace "Luces LED" del menú, que apuntaba a los volantes.
 * Para deshacerlo basta con quitar la línea que carga este archivo en layout/theme.liquid.
 */
(function () {
  'use strict';

  // Sin fondo 3D en la portada: se quita el lienzo antes de que el tema lo inicie,
  // y se evita descargar la librería Three.js (nada más en la web la usa).
  (function quitarFondo3D() {
    var wrap = document.getElementById('hero3dWrap');
    if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
    if (!window.THREE) window.THREE = { __desactivado: true };
  })();

  // Textos exactos (se compara el texto completo del nodo, sin espacios sobrantes)
  var EXACT = {
    'ADD TO CART': 'AÑADIR AL CARRITO',
    'ADDING TO CART...': 'AÑADIENDO...',
    '✓ ADDED TO CART!': '✓ ¡AÑADIDO AL CARRITO!',
    '2-Year Warranty': '3 años de garantía',
    'Optional Installation': 'Instalación opcional',
    '24/7 Support': 'Soporte 24/7',
    'Important Information': 'Información importante',
    'Design & Material': 'Diseño y materiales',
    'Vehicle Compatibility': 'Compatibilidad con tu vehículo',
    'LED Display': 'Pantalla LED',
    'Optional Components': 'Componentes opcionales',
    'M1 / M2 Buttons': 'Botones M1 / M2',
    'ACC, Heating & Vibration': 'ACC, calefacción y vibración',
    'Fitment Confirmation': 'Confirmación de compatibilidad',
    'Installation': 'Instalación',
    'What Is Included': 'Qué incluye',
    'We like to keep it personal': 'Tu 10% de bienvenida te espera',
    'ON ALL PARTS': 'EN TODA LA TIENDA',
    'Your birthday / Your car': 'Tu cumpleaños o tu coche',
    "We don't miss birthdays. Drop yours and get surprises when it matters.":
      'No nos olvidamos de los cumpleaños: déjanos el tuyo y te llevarás una sorpresa.',
    'SIGN ME UP!': '¡QUIERO MI 10%!',
    'GET 10% OFF!': '¡TU 10% DTO!'
  };

  // Textos que empiezan igual (el resto del nodo se conserva)
  var PREFIX = [
    ['Level up your build. ', 'Mejora tu coche. '],
    ['CHECKOUT', 'FINALIZAR COMPRA']
  ];

  var PLACEHOLDERS = {
    'First name': 'Nombre',
    'Last name': 'Apellidos'
  };

  // Nombres de producto del catálogo de script.js que tenían tildes estropeadas ("?")
  function fixCatalogNames() {
    try {
      if (typeof PRODUCTS === 'undefined' || !PRODUCTS.forEach) return;
      PRODUCTS.forEach(function (p) {
        if (!p || typeof p.name !== 'string') return;
        p.name = p.name
          .replace(/^T\?tulo\s+/, '')
          .replace(/Alc\?ntara/g, 'Alcántara')
          .replace(/Marr\?n/g, 'Marrón');
      });
    } catch (e) { /* sin catálogo en esta página */ }
  }
  fixCatalogNames();

  function fixText(node) {
    var raw = node.nodeValue;
    if (!raw) return;
    if (raw.indexOf('?') !== -1) {
      if (/T\?tulo|Alc\?ntara|Marr\?n|ALC\?NTARA|MARR\?N|T\?TULO|t\?\?cnico|dise\?\?amos/.test(raw)) {
        raw = raw
          .replace(/T\?tulo\s+/g, '').replace(/T\?TULO\s+/g, '')
          .replace(/Alc\?ntara/g, 'Alcántara').replace(/ALC\?NTARA/g, 'ALCÁNTARA')
          .replace(/Marr\?n/g, 'Marrón').replace(/MARR\?N/g, 'MARRÓN')
          .replace(/t\?\?cnico/g, 'técnico').replace(/dise\?\?amos/g, 'diseñamos');
        node.nodeValue = raw;
      } else if (raw.trim() === '???') {
        // Icono roto del mensaje "Configuración a medida"
        node.nodeValue = raw.replace('???', '🛠️');
        return;
      }
    }
    var t = raw.trim();
    if (!t) return;
    if (Object.prototype.hasOwnProperty.call(EXACT, t)) {
      node.nodeValue = raw.replace(t, EXACT[t]);
      return;
    }
    for (var i = 0; i < PREFIX.length; i++) {
      if (t.indexOf(PREFIX[i][0]) === 0) {
        node.nodeValue = raw.replace(PREFIX[i][0], PREFIX[i][1]);
        return;
      }
    }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType !== 1 || root.nodeName === 'SCRIPT' || root.nodeName === 'STYLE') return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) fixText(n);
    var inputs = root.querySelectorAll ? root.querySelectorAll('input[placeholder]') : [];
    for (var j = 0; j < inputs.length; j++) {
      var ph = inputs[j].getAttribute('placeholder');
      if (PLACEHOLDERS[ph]) inputs[j].setAttribute('placeholder', PLACEHOLDERS[ph]);
    }
  }

  function fixLinks() {
    var luces = document.querySelector('.nav-dropdown-item.item-highlight-led');
    if (luces && luces.getAttribute('href') === '?view=volantes') {
      luces.setAttribute('href', '?view=luces');
    }
  }

  function start() {
    walk(document.body);
    fixLinks();
    var busy = false;
    var obs = new MutationObserver(function (records) {
      if (busy) return;
      busy = true;
      try {
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          if (r.type === 'characterData') fixText(r.target);
          else for (var k = 0; k < r.addedNodes.length; k++) walk(r.addedNodes[k]);
        }
      } finally {
        busy = false;
      }
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
